<template>
  <BaseModal
    :modal-class="'add-diet-modal'"
    @close="hideAddDietModal"
    @confirm="addDiet"
    @click="deactivateSelects"
  >
    <template #title>Dodawanie jadłospisu</template>
    <div class="modal-label">Wprowadź nazwę jadłospisu</div>
    <BaseInput
      v-model="addDietModal.name"
      test-id="AddDietModal__Name"
      class="add-diet-modal__input"
      :maxlength="85"
      :placeholder="'Twoja nazwa jadłospisu'"
      :force-focus="true"
    />
    <div class="modal-label">Wybierz grupę dla jadłospisu</div>
    <BaseSelect v-model="addDietModal.groupId" :options="addDietModalGroups" />
    <template #actions>
      <StyledButton variant="outline" @click.once="hideAddDietModal">Anuluj</StyledButton>
      <StyledButton :disabled="addDietButtonDisabled" @click.once="addDiet">
        Dodaj jadłospis
      </StyledButton>
    </template>
  </BaseModal>
</template>

<script lang="ts" setup>
  import { onBeforeUnmount } from 'vue'

  import BaseInput from '@/components/BaseInput.vue'
  import BaseModal from '@/components/BaseModal.vue'
  import BaseSelect from '@/components/BaseSelect.vue'
  import { StyledButton } from '@/components/StyledButton'

  import { useDietListGroupsProvider } from '../providers/dietListGroupsProvider'

  const {
    addDiet,
    addDietButtonDisabled,
    addDietModalGroups,
    addDietModal,
    deactivateSelects,
    hideAddDietModal,
  } = useDietListGroupsProvider()

  onBeforeUnmount(() => {
    addDietModal.value.dietDisplayType = 'days_of_week'
  })
</script>

<style scoped>
  .modal-label {
    font-size: 10px;
    color: var(--color-tertiary-text);
  }

  .add-group-modal__input {
    width: 100%;
  }

  .add-diet-modal__input {
    width: 100%;
    margin-bottom: 20px;
  }
</style>

<style>
  .add-diet-modal {
    overflow: visible !important;
  }
</style>
